// ─── Единая модель фильтрации для POST /employees/search и POST /employees/export

// Направление сортировки
export type SortDirection = 'asc' | 'desc';

export interface SortSpec {
    field: string | null;
    direction: SortDirection | null;
}

// ─── FilterSpec — единый фильтр (как на бэкенде) ────────────────────────────
// value и value2 — any, т.к. бэкенд принимает строки, числа, массивы
// value2 используется для операторов типа `between` (значение "до")

export interface FilterSpec {
    field: string | null;
    type: string | null;
    operator: string | null;
    value?: unknown;
    value2?: unknown;
}

// ─── Тело запроса POST /employees/search ─────────────────────────────────────

export interface EmployeeSearchRequest {
    page: number;
    pageSize: number;
    asOfDate: string | null;
    sort: SortSpec[] | null;
    filters: FilterSpec[] | null;
}

// ─── Тело запроса POST /employees/export ─────────────────────────────────────

export interface EmployeeExportRequest extends EmployeeSearchRequest {
    columns?: string[] | null;
}

// ─── Стейт фильтров на фронте (хранится в TableStateService) ─────────────────

export interface FilterState {
    visibleColumns: string[];
    rules: FilterSpec[];
    sort: SortSpec[];
    page: number;
    pageSize: number;
    asOfDate: string | null;
}

export const DEFAULT_FILTER_STATE: FilterState = {
    visibleColumns: [],
    rules: [],
    sort: [],
    page: 1,
    pageSize: 50,
    asOfDate: null,
};
